/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex'; 
export default {
  name: 'home-dashboard',
  components: {},
  props: [],
  data () {
    return {
      userDetails:{},
      userUpdates:{},
      userUpdatesList:[],
      loadmoreData: {},
      userLoading: false,
      nextStep:'',
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'getNuAcUpdatesListGetters'
    ]),
  getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    return
  },
  getUserUpdatesList(){
    this.userUpdates = this.$store.getters.getNuAcUpdatesListGetters.data
    return
  },
  setInitialStates(){
    if(this.userUpdates != undefined){
      this.nextStep = this.userUpdates.next
      this.userUpdatesList = this.userUpdates.results
    }
  }
  },
  mounted () {
    this.getUserDetailsAgainFun
    this.getUserUpdatesList
    this.setInitialStates
  },
  methods: {
    showLoadMoreDataFun(url) {
      this.userLoading = true
      console.log(url, "Next URL LINK")
      axios.get(url).then((response) => {
        console.log(response.data.data.next)
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.userUpdatesList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.userUpdatesList.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getUserDetailsAgain() {
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.userDetails = res.data.data
      }).catch((err) => {
      })
    },
    userStatusUpdatedFun(userDetails, userStatus){
      var is_public = userStatus
      if(userStatus == false){
        is_public = true
      }else{
        is_public = false
      }
      // console.log(userStatus, is_public, "User Status CHecking")
      let data = new FormData();
      data.append('is_public', is_public);
      this.$store.dispatch('updateProfileFun', data)
        .then((res) => {
          toast.success(res.data.msg);
          this.getUserDetailsAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.data.email);
        })
      return;
    }
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    getUserUpdatesList(){
      return this.$store.getters.getNuAcUpdatesListGetters.data
    },
    setInitialStates(){
      if(this.userUpdates != undefined){
        this.nextStep = this.userUpdates.next
        this.userUpdatesList = this.userUpdates.results
      }
    }
  },
}